export const defaultValues = {
  to: "#",
  lang: { us: "en-US", en: "en-EN", id:"id-ID" },
};
